import { AuthedRoute } from "../../helpers/authed-route";
import { ApplsContainer } from "../../pages/smart-apply/applications";
import { ApplicationDetailContainer } from "../../pages/smart-apply/application-detail";
import { ProceduresContainer } from "../../pages/smart-apply/procedures";
import { ProcedureDetailContainer } from "../../pages/smart-apply/procedure-detail";
import { CustomerReviewsContainer } from "../../pages/smart-apply/customer-reviews";
import {
  NamedRoute,
  route,
} from "../../../application/domain/routing/named-route";
import { Redirect, Route } from "react-router-dom";
import { PaymentDetailContainer } from "./application-payment-detail";
import { TabUiState } from "../../../application/service/smart-apply/application-detail/tab-ui-state";
import { ApplicationTaskDetailContainer } from "./application-task-detail";
import { PdfOutputConfiguration } from "../../organisms/smart-apply/procedure-detail/pdf-output-configuration/pdf-output-configuration";
import { QualifiedInvoiceNewContainer } from "./application-qualified-invoice/new";
import { QualifiedInvoiceShowContainer } from "./application-qualified-invoice/show";
import { ArchivedProceduresList } from "./archived-procedures";
import { QualifiedInvoiceIssueRequestsContainer } from "./qualified-invoice/issue-requests";
import { AssignedApplications } from "./assigned-applications";
import { ApplicationRemovalTaskList } from "./application-removal-task";
import { ApplicationRemovalTaskRegister } from "./application-removal-task/register";
import { ApplicationRemovalTaskDetail } from "./application-removal-task/detail";
import ProcedureAssignmentSettingRuleSetListContainer from "./procedure-assignment-setting-rulesets/list/container";
import ProcedureAssignmentSettingRulesetNewContainer from "./procedure-assignment-setting-rulesets/new/container";
import ProcedureAssignmentSettingRulesetEditContainer from "./procedure-assignment-setting-rulesets/edit/container";

export const SmartApplyR = {
  Applications: route({
    path: "/smart-apply/applications",
    component: ApplsContainer,
  }),
  ApplicationDetail: route({
    path: "/smart-apply/applications/:id",
    link: (args: { id: string; tab?: TabUiState }) =>
      `/smart-apply/applications/${args.id}${
        args.tab ? `?tab=${args.tab.getValue()}` : ""
      }`,
    component: ApplicationDetailContainer,
  }),
  AssignedApplications: route({
    path: "/smart-apply/assigned-applications",
    component: AssignedApplications,
  }),
  ApplicationRemovalTaskList: route({
    path: "/smart-apply/application-removal-tasks",
    component: ApplicationRemovalTaskList,
  }),
  ApplicationRemovalTaskRegister: route({
    path: "/smart-apply/application-removal-task/register",
    component: ApplicationRemovalTaskRegister,
  }),
  ApplicationRemovalTaskDetail: route({
    path: "/smart-apply/application-removal-tasks/:id",
    link: (args: { id: string }) =>
      `/smart-apply/application-removal-tasks/${args.id}`,
    component: ApplicationRemovalTaskDetail,
  }),
  ApplicationPaymentDetail: route({
    path: "/smart-apply/applications/:id/payments/:index",
    link: (args: { id: string; index: number }) =>
      `/smart-apply/applications/${args.id}/payments/${args.index}`,
    component: PaymentDetailContainer,
  }),
  ApplicationQualifiedInvoiceNew: route({
    path: "/smart-apply/applications/:id/qualified-invoice/new",
    link: (args: { id: string }) =>
      `/smart-apply/applications/${args.id}/qualified-invoice/new`,
    component: QualifiedInvoiceNewContainer,
  }),
  ApplicationQualifiedInvoiceShow: route({
    path: "/smart-apply/applications/:id/qualified-invoices/:qualifiedInvoiceId",
    link: (args: { id: string; qualifiedInvoiceId: string }) =>
      `/smart-apply/applications/${args.id}/qualified-invoices/${args.qualifiedInvoiceId}`,
    component: QualifiedInvoiceShowContainer,
  }),
  ApplicationTaskDetail: route({
    path: "/smart-apply/application-tasks/:id",
    link: (args: { id: string }) => `/smart-apply/application-tasks/${args.id}`,
    component: ApplicationTaskDetailContainer,
  }),
  Procedures: route({
    path: "/smart-apply/procedures",
    component: ProceduresContainer,
  }),
  ArchivedProcedures: route({
    path: "/smart-apply/archived-procedures",
    component: ArchivedProceduresList,
  }),
  ProcedureDetail: route({
    path: "/smart-apply/procedures/:id",
    link: (args: { id: string }) => `/smart-apply/procedures/${args.id}`,
    component: ProcedureDetailContainer,
  }),
  ProcedurePDFOutputConfiguration: route({
    path: "/smart-apply/procedures/:procedureId/pdf-output-configuration",
    link: (args: { procedureId: string }) =>
      `/smart-apply/procedures/${args.procedureId}/pdf-output-configuration`,
    component: PdfOutputConfiguration,
  }),
  CustomerReviews: route({
    path: "/smart-apply/customer-reviews",
    component: CustomerReviewsContainer,
  }),
  QualifiedInvoiceIssueRequests: route({
    path: "/smart-apply/qualified-invoice/issue-requests",
    component: QualifiedInvoiceIssueRequestsContainer,
  }),
  AssignmentSettingRulesets: route({
    path: "/smart-apply/assignment-setting-rulesets",
    component: ProcedureAssignmentSettingRuleSetListContainer,
  }),
  AssignmentSettingRulesetCreate: route({
    path: "/smart-apply/assignment-setting-rulesets/new",
    component: ProcedureAssignmentSettingRulesetNewContainer,
  }),
  AssignmentSettingRulesetEdit: route({
    path: "/smart-apply/assignment-setting-rulesets/edit/:id",
    link: (args: { id: string }) =>
      `/smart-apply/assignment-setting-rulesets/edit/${args.id}`,
    component: ProcedureAssignmentSettingRulesetEditContainer,
  }),
};

export const SmartApplyRoutes = () => {
  return (
    <>
      {Object.keys(SmartApplyR).map((k: string) => {
        const r = (SmartApplyR as { [key: string]: NamedRoute<any> })[k]
          .forRouter;
        return (
          <AuthedRoute
            exact
            path={r.path}
            component={r.component}
            key={`SmartApplyRoutes-${k}`}
          />
        );
      })}
      <Route
        exact={true}
        path="/applications"
        render={() => <Redirect exact to={SmartApplyR.Applications.link({})} />}
      />
      <Route
        exact={true}
        path="/applications/:id"
        render={(props) => (
          <Redirect
            exact
            to={SmartApplyR.ApplicationDetail.link({
              id: props.match.params.id,
            })}
          />
        )}
      />
    </>
  );
};
